import React, { useState } from "react";
import ModalModern from "../ModalModern";
import ModernPopupHeader from "../common/ModernPopupHeader";
import ModernPopupBody from "../common/ModernPopupBody";
import { getInitialsIconSrc } from "../../../../utils/images/iconUtils";
import { bulkUpdateIncomeConfirmation } from "../../../../api/finances/incomeAPI";

function IncomeDecisionReviewModal({
  title = "Income Verification",
  transactions = [],
  onClose,
  onSuccess,
}) {
  const [decisions, setDecisions] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const getTransactionIconSrc = (transaction) =>
    transaction.logo_url ||
    getInitialsIconSrc(transaction.name || "Transaction");

  const handleSelectDecision = (transactionUuid, value) => {
    setDecisions((prev) => ({ ...prev, [transactionUuid]: value }));
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    setSubmitError("");
    try {
      await bulkUpdateIncomeConfirmation({ decisions });

      if (typeof onSuccess === "function") {
        await onSuccess();
      }
      onClose();
    } catch (err) {
      setSubmitError("Failed to save changes. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const isFormComplete =
    transactions.length > 0 && transactions.some((t) => decisions[t.uuid]);

  return (
    <ModalModern onClose={onClose}>
      <ModernPopupHeader onClose={onClose}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <h3 className="transaction-popup-title" style={{ margin: 0 }}>
            {title}
          </h3>
        </div>
      </ModernPopupHeader>

      <ModernPopupBody>
        <div style={{ display: "flex", flexDirection: "column" }}>
          {submitError && (
            <span
              style={{
                fontSize: "14px",
                color: "#EF4444",
                marginBottom: "12px",
              }}
            >
              {submitError}
            </span>
          )}

          {transactions.map((t, index) => {
            const transactionKey = t.uuid;
            const currentSelection = decisions[transactionKey];

            const formattedAmount = Number(t.amount || 0).toLocaleString(
              undefined,
              { minimumFractionDigits: 2 },
            );

            return (
              <div
                key={transactionKey}
                className="classify-spending-container"
                style={{
                  justifyContent: "space-between",
                  padding: "24px 0",
                  borderBottom:
                    index !== transactions.length - 1
                      ? "1px solid #F3F4F6"
                      : "none",
                }}
              >
                <div
                  style={{ display: "flex", gap: "12px", alignItems: "center" }}
                >
                  <img
                    src={getTransactionIconSrc(t)}
                    alt=""
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                    }}
                  />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span
                      style={{
                        fontWeight: "500",
                        color: "#374151",
                        fontSize: "15px",
                      }}
                    >
                      {t.name}
                    </span>
                    <span style={{ fontSize: "12px", color: "#9CA3AF" }}>
                      {t.date} {t.account_name ? `• ${t.account_name}` : ""}
                    </span>
                  </div>
                </div>

                <div className="classify-spending-actions">
                  <span
                    style={{
                      fontWeight: "600",
                      fontSize: "16px",
                      color: "#10B981", // Green accent for income
                      minWidth: "70px",
                      textAlign: "right",
                    }}
                  >
                    +${formattedAmount}
                  </span>

                  <div
                    className="utc-header-filtering"
                    style={{ width: "fit-content", margin: 0, padding: "2px" }}
                  >
                    <div
                      className={`utc-header-filtering-item ${
                        currentSelection === "IN" ? "active" : ""
                      }`}
                      onClick={() => handleSelectDecision(transactionKey, "IN")}
                      style={{
                        cursor: "pointer",
                        fontSize: "12px",
                        padding: "4px 10px",
                      }}
                    >
                      Income
                    </div>
                    <div
                      className={`utc-header-filtering-item ${
                        currentSelection === "NI" ? "active" : ""
                      }`}
                      onClick={() => handleSelectDecision(transactionKey, "NI")}
                      style={{
                        cursor: "pointer",
                        fontSize: "12px",
                        padding: "4px 10px",
                      }}
                    >
                      Not Income
                    </div>
                  </div>
                </div>
              </div>
            );
          })}

          <div className="classiy-spendings-buttons">
            <button
              onClick={onClose}
              className="cta-button secondary rounded"
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="cta-button primary rounded"
              disabled={!isFormComplete || submitting}
            >
              {submitting ? "Saving..." : "Confirm Decisions"}
            </button>
          </div>
        </div>
      </ModernPopupBody>
    </ModalModern>
  );
}

export default IncomeDecisionReviewModal;
